import { render, staticRenderFns } from "./Entrenadores.vue?vue&type=template&id=dcb5c226&scoped=true&"
import script from "./Entrenadores.vue?vue&type=script&lang=js&"
export * from "./Entrenadores.vue?vue&type=script&lang=js&"
import style0 from "./Entrenadores.vue?vue&type=style&index=0&id=dcb5c226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb5c226",
  null
  
)

export default component.exports